const setHeight =()=>{
    const currentHeight = (window.innerHeight-72);
    const item = document.getElementsByClassName("callResize");

    if(item.length !== 0){
        item[0].style.height = `${currentHeight}px`;
    }
  }

export default setHeight;